import { cloudChiprApi, Dashboard } from "../../../../services/cloudchipr.api";
import { RootState } from "../../../store";

const selector =
  cloudChiprApi.endpoints.getUsersMeOrganisationsCurrentDashboards.select({});

export const dashboardsSelector = (state: RootState): Dashboard[] | null => {
  return selector(state)?.data ?? null;
};
